import { Reference } from '@approvalmax/types';
import { compareHelpers, mathService } from '@approvalmax/utils';
import { backend, domain } from 'modules/data';
import { mapBeneficiary } from 'modules/data/domain/schemas';
import { mapAttachment } from 'modules/data/domain/schemas/requestSchema';

export const mapAirwallexXeroBillInvoiceRequests = (
    requests: backend.XeroAirwallexBillInvoiceRequest[],
    currencies: string[],
    companyCurrency: string,
    paymentFees: Reference[]
): domain.AirwallexBatchSelectableBillItem[] => {
    return requests.map((request) => {
        let beneficiary: domain.AirwallexBeneficiary | null =
            (request.lastUsedBeneficiary && mapBeneficiary(request.lastUsedBeneficiary)) || null;

        if (beneficiary && !currencies.includes(beneficiary.accountCurrency)) {
            beneficiary = null;
        }

        const paymentMethod = beneficiary?.paymentMethod || null;
        const paymentFee = paymentFees.find((paymentFee) => paymentFee.id === beneficiary?.paymentFee?.id) || null;

        return {
            id: request.xeroBillInvoiceRequestId,
            currency: request.currency,
            plannedDate: request.plannedDate,
            xeroBillInvoiceRequestId: request.xeroBillInvoiceRequestId,
            orderNumber: 0,
            friendlyName: request.friendlyName,
            date: request.date,
            dueDate: request.dueDate,
            amountDue: request.amountDue,
            note: request.note,
            contact: {
                id: request.contact.id,
                text: request.contact.name,
            },
            selected: false,
            details: request.details,
            amountOnApproval: request.amountOnApproval || 0,
            amountInProcessing: request.amountInProcessing || 0,
            amountAwaitingPayment: request.amountAwaitingPayment || 0,
            amountOnReview: request.amountOnReview || 0,
            amount: mathService.subtract(
                request.amountDue,
                mathService.add(
                    mathService.add(request.amountInProcessing || 0, request.amountOnApproval || 0),
                    request.amountAwaitingPayment || 0
                )
            ),
            reference: request.reference,
            code: request.code,
            particulars: request.particulars,
            xeroBillInvoiceReference: request.xeroBillInvoiceReference,
            defaultBankAccount: request.bankAccountNumber || null,
            attachments: (request.attachments || [])
                .map(mapAttachment)
                .sort(
                    compareHelpers.comparatorFor<domain.RequestAttachment>(compareHelpers.stringComparator2Asc, 'name')
                ),
            outstandingBalance: request.outstandingBalance,
            overdueBalance: request.overdueBalance,
            beneficiary: beneficiary,
            paymentReference: request.reference || request.details || request.xeroBillInvoiceReference || '',
            paymentPurpose: null,
            paymentMethod: paymentMethod,
            sourceCurrency: currencies.includes(request.currency)
                ? { id: request.currency, text: request.currency }
                : { id: companyCurrency, text: companyCurrency },
            bankAccount: null,
            paymentFee: paymentMethod?.id === domain.AirwallexPaymentMethod.Swift ? paymentFee : null,
            sourceAmount: request.sourceAmount,
            feeAmount: request.feeAmount,
            status: request.status,
            errorMessage: request.errorMessage,
            statusUpdatedAt: request.statusUpdatedAt,
            xeroUrl: request.xeroUrl,
            airwallexUrl: request.airwallexUrl,
            beneficiaryPaymentStatus: null,
            beneficiaryDiscrepancy: null,
        };
    });
};
